import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../user/user.api";
import { ApiBaseUrl } from "../../http";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { IVille, VilleFormData } from "./ville.type";
import { QueryUrl } from '../../Utils';

const VilleApi = createApi({
  reducerPath: "villeApi",
  tagTypes: ["ville"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    addOrUpdateVille: build.mutation<IVille, { slug?: string; data: IVille }>({
      query: ({ slug, data }) => ({
        url: slug ? `villes/${slug}/` : `villes/`,
        method: slug ? "PUT" : "POST",
        body: data,
      }),
      invalidatesTags: ["ville"],
    }),
    getVilles: build.query<PaginationResults<IVille>, TypeQuery>({
      query: (query) => QueryUrl("villes", query),
      providesTags: ["ville"],
    }),
    deleteVille: build.mutation<VilleFormData, string>({
      query: (slug) => ({
        url: `villes/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ville"],
    }),
  }),
});

export default VilleApi;

export const {
  useAddOrUpdateVilleMutation,
  useDeleteVilleMutation,
  useGetVillesQuery,
} = VilleApi;
